module.exports = "https://www.gc-qa.gnp.com.mx/deb27a348ee77745bec0f08d8db51d84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/05-rc-over.svg
// module id = 8039
// module chunks = 0